import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SupportContactService } from '../../../services/support-contact.service';

@Component({
  selector: 'app-contact-info',
  imports: [],
  templateUrl: './contact-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-info.component.scss',
})
export class ContactInfoComponent implements OnInit, OnDestroy {
  public mailLink = '';

  private supportContactService = inject(SupportContactService);
  private subscription?: Subscription;

  public ngOnInit(): void {
    this.evaluateSupportMailLink();
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private evaluateSupportMailLink(): void {
    this.subscription = this.supportContactService.getSupportMailLink$().subscribe({
      next: (mailLink) => {
        this.mailLink = mailLink;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
}
